var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row flexwrap"},_vm._l((_vm.counts),function(v,k){return _c('div',{key:k,staticClass:"col countbox"},[_c('CountBox',{attrs:{"compact":true,"count":v['count'],"name":v.label,"primary-color-var":'--sizzle-' + v.color}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }